export default __webpack_public_path__ + "static/media/pope_worldwide_pt.3e45acc7.svg";